import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/elements/button';
import FarmRegistration from '../../components/aquadoc/FarmRegistration';
// import HealthStatus from '../../components/aquadoc/HealthStatus';
// import WaterQuality from '../../components/aquadoc/WaterQuality';
// import ComplaintHistory from '../../components/aquadoc/ComplaintHistory';
import '../../assets/css/pages/aquadoc.css';
import fish from '../../assets/images/fish.jpg';
import { Row } from 'react-bootstrap';
import { toast } from 'react-toastify';

const AquaDoc = () => {
    const navigate = useNavigate();
    const [showFarmForm, setShowFarmForm] = useState(false);
    const userData = JSON.parse(localStorage.getItem('user'));
    const handleViewDashboard = () => {
        if (userData !== null) {
            if (userData.is_doctor) {
                navigate('/vet');
            } else if (userData.is_vendor) {
                navigate('/vendor');
            } else if (userData.is_lab) {
                navigate('/lab');
            } else if (userData.is_admin) {
                navigate('/admin');
            } else {
                navigate('/dashboard');
            }
        } else {
            toast.warn("Login to view dashboard")
        }
    }

    return (
        <div className="aquadoc-page">
            {/* Hero Section */}
            <section className="hero-section aquadoc">
                <div className="hero-content aquadoc">
                    <h1>Your Personal Aquaculture Health Assistant</h1>
                    <p>Get instant access to veterinary expertise and farm health monitoring</p>
                    <Row className=''>
                        <Button 
                            fullWidth={false}
                            text="View Dashboard"
                            variant="primary"
                            onClick={handleViewDashboard}
                        />
                    </Row>
                </div>
                <div className="hero-image aquadoc">
                    <img src={fish} alt="AquaDoc Veterinary" />
                </div>
            </section>

            {/* Stats Section */}
            <section className="stats-section">
                <div className="stats-grid">
                    <div className="stat-card doctors">
                        <div className="stat-icon">
                            <i className="fas fa-user-md"></i>
                        </div>
                        <div className="stat-content">
                            <h3>Available Doctors</h3>
                            <span className="stat-number">124</span>
                            <p>Available now</p>
                        </div>
                    </div>

                    <div className="stat-card cases">
                        <div className="stat-icon">
                            <i className="fas fa-check-circle"></i>
                        </div>
                        <div className="stat-content">
                            <h3>Cases Resolved</h3>
                            <span className="stat-number">1,240</span>
                            <p>This month</p>
                        </div>
                    </div>

                    <div className="stat-card farms">
                        <div className="stat-icon">
                            <i className="fas fa-water"></i>
                        </div>
                        <div className="stat-content">
                            <h3>Active Farms</h3>
                            <span className="stat-number">456</span>
                            <p>Registered farms</p>
                        </div>
                    </div>

                    <div className="stat-card capacity">
                        <div className="stat-icon">
                            <i className="fas fa-fish"></i>
                        </div>
                        <div className="stat-content">
                            <h3>Avg. Number of Fish</h3>
                            <span className="stat-number">2.5M</span>
                            <p>Fish monitored</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Farm Registration Modal */}
            {showFarmForm && (
                <FarmRegistration onClose={() => setShowFarmForm(false)} />
            )}

            {/* AI Chat Prompt */}
            <section className="ai-chat-prompt">
                <h2>Having Issues with Your Farm?</h2>
                <p>Chat with our AI diagnostic assistant for instant help</p>
                <Button 
                    text="Start Chat"
                    variant="primary"
                    onClick={() => navigate('/chat')}
                />
            </section>
        </div>
    );
};

export default AquaDoc;